import rg4js from "raygun4js";
import React, { ErrorInfo, ReactNode } from "react";
import { View } from "react-native";
import { Text } from "react-native-paper";
import Toolbar from "@mui/material/Toolbar";
import AppBar from "@mui/material/AppBar";

import config from "../config";
import WebErrorIcon from "../svgs/WebError";
import PgaLogo from "../svgs/PgaLogo";
import { colors } from "../../theme";
import LinkButton from "./LinkButton";
import { useIntercomClient } from "../hooks/useIntercom";

interface Props {
  children?: ReactNode;
}
interface State {
  hasError: boolean;
}

const ContactLink = () => {
  const intercom = useIntercomClient();

  return (
    <LinkButton className="mt-4" onPress={() => intercom.presentMessageComposer()}>
      Contact Member Services
    </LinkButton>
  );
};

class ErrorBoundary extends React.Component<Props, State> {
  state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (config.raygunApiKey) {
      rg4js("send", {
        error,
        customData: errorInfo,
      });
    }
    console.error("Uncaught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <AppBar
            position="fixed"
            color="inherit"
            elevation={0}
            sx={{ borderBottom: colors.sky.light, borderBottomWidth: 1, borderBottomStyle: "solid" }}
          >
            <Toolbar sx={{ justifyContent: "center" }}>
              <PgaLogo />
            </Toolbar>
          </AppBar>
          <View className="items-center justify-center h-full m-auto max-w-3xl">
            <WebErrorIcon />
            <Text className="text-title-5 text-ink-light font-700 mt-4">Oops, something went wrong...</Text>
            <Text className="text-regular-normal text-ink-light font-400 mt-4 text-center w-2/3">
              Due to an unknown error, this content could not be loaded. Please wait a moment and try again. If the problem
              persists, please contact member services.
            </Text>
            <ContactLink />
          </View>
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
